import React from "react";
import { Card } from "../../ui";
import { DASHBOARD_TEXT } from "../data/dashboardText";
import { describeSubscription } from "../data/subscriptionSummary";

export default function BrandAndQuickCards({
  lang,
  dashboard,
  restaurant,
  subscription,
}) {
  const t = DASHBOARD_TEXT[lang].subscription;
  const sub = describeSubscription(subscription, DASHBOARD_TEXT[lang]);
  const logoDocument = (dashboard.organizationDocuments || []).find((document) => {
    const key = String(document.key || "").toLowerCase();
    const titleAr = String(document.titleAr || "");
    const titleEn = String(document.titleEn || "").toLowerCase();
    return key.includes("logo") || titleAr.includes("شعار") || titleEn.includes("logo");
  });

  const logoFile = logoDocument?.file || null;
  const logoUrl =
    logoFile?.url ||
    logoFile?.secure_url ||
    logoFile?.secureUrl ||
    dashboard.store?.moreDetails?.restaurantLogo ||
    "";

  return (
    <section className="lud-brand-quick-grid">
      <Card className="lud-dashboard-brand-card">
        <div className="lud-brand-top">
          <div className={`lud-logo-placeholder${logoUrl ? " has-image" : ""}`}>
            {logoUrl ? (
              <img src={logoUrl} alt={lang === "ar" ? "شعار المطعم" : "Restaurant logo"} />
            ) : lang === "ar" ? (
              "اللوقو"
            ) : (
              "Logo"
            )}
          </div>
          <div>
            <h2>{lang === "ar" ? restaurant.nameAr : restaurant.nameEn}</h2>
            <p>
              LUD ID: {restaurant.id} · {restaurant.branches} {lang === "ar" ? "فروع" : "branches"}
            </p>
          </div>
        </div>
        <details open>
          <summary>
            {sub.ready
              ? [
                  `${t.account} ${sub.accountStatus}`,
                  sub.subscriptionStatus,
                  sub.planCode && `${t.packagePrefix} ${sub.planCode}`,
                ]
                  .filter(Boolean)
                  .join(" · ")
              : sub.message}
          </summary>
          <div className="lud-subscription-mini-panel">
            {sub.ready && (
              <>
                <span>
                  {t.accountStatus}: <strong>{sub.accountStatus}</strong>
                </span>
                <span>
                  {t.package}: <strong>{sub.planCode || "-"}</strong>
                </span>
                <span>
                  {t.startDate}: {sub.startDate || "-"}
                </span>
                <span>
                  {t.endDate}: {sub.endDate || "-"}
                </span>
                <span>
                  {t.remaining}:{" "}
                  {sub.remainingDays === null
                    ? "-"
                    : `${sub.remainingDays} ${t.days}`}
                </span>
                {sub.cancellationEffectiveAt && (
                  <span>
                    {t.cancellationEffective}: {sub.cancellationEffectiveAt}
                  </span>
                )}
                {sub.coverage && (
                  <>
                    <span data-testid="coverage-covered">
                      {t.coveredBranches}: <strong>{sub.coverage.covered}</strong> {t.ofTotal} <strong>{sub.coverage.total}</strong>
                    </span>
                    {sub.coverage.uncovered > 0 && (
                      <span data-testid="coverage-uncovered">
                        {t.uncoveredBranches}: <strong>{sub.coverage.uncovered}</strong>
                      </span>
                    )}
                    {sub.coverage.origin === "admin_grant" && sub.coverage.grantEndDate && (
                      <span>
                        {t.grantedUntil}: {String(sub.coverage.grantEndDate).slice(0, 10)}
                      </span>
                    )}
                    {sub.coverage.conversionPending && sub.coverage.grantEndDate && (
                      <span>
                        {t.converting}: {String(sub.coverage.grantEndDate).slice(0, 10)}
                      </span>
                    )}
                    {sub.coverage.operationalUncovered > 0 && (
                      <span role="alert" data-testid="coverage-alert">
                        {t.uncoveredNotice}{" "}
                        <a href={`/auth/billing${sub.storeId ? `?storeId=${encodeURIComponent(sub.storeId)}` : ""}`}>{t.coverageAction}</a>
                      </span>
                    )}
                  </>
                )}
              </>
            )}
            <span>
              {lang === "ar" ? "المدينة" : "City"}: {restaurant.city || "-"}
            </span>
            <span>
              {lang === "ar" ? "الفروع" : "Branches"}: {restaurant.branches || 0}
            </span>
          </div>
        </details>
      </Card>

      <Card className="lud-quick-card">
        <h2>{lang === "ar" ? "المؤشرات السريعة" : "Quick Indicators"}</h2>
        <div className="lud-quick-grid">
          <span>
            <strong>{(dashboard.operations || []).filter((item) => item.status === "rejected").length}</strong>
            {lang === "ar" ? "اعتراضات" : "Objections"}
          </span>
          <span>
            <strong>{dashboard.notificationCount ?? (dashboard.notifications || []).length}</strong>
            {lang === "ar" ? "تنبيهات" : "Alerts"}
          </span>
          <span>
            <strong>{dashboard.requests.length}</strong>
            {lang === "ar" ? "إجراءات" : "Actions"}
          </span>
          <span>
            <strong>{dashboard.completionPercent}%</strong>
            {lang === "ar" ? "اكتمال الحساب" : "Completion"}
          </span>
          <span>
            <strong>{dashboard.requests.filter((item) => item.status === "pending").length}</strong>
            {lang === "ar" ? "طلبات معلقة" : "Pending"}
          </span>
        </div>
      </Card>
    </section>
  );
}
